import { CommonProps } from "@/components/forms/types";

export const createDateTimeValidation = ({ baseValidation }: { baseValidation?: CommonProps["validation"] }) => {
    if (typeof baseValidation === "string") {
        let modified = `${baseValidation}`;

        if (!modified.match(/(^kdate|\|kdate\||\|kdate$)/g)) {
            // Avslutar resten av valideringen om kdate failar (det är vad ^ betyder)
            modified = `^kdate|${modified}`;
        }

        if (!modified.match(/(^kdatemin|\|kdatemin\||\|kdatemin$)/g)) {
            modified = `kdatemin|${modified}`;
        }

        if (!modified.match(/(^kdatemax|\|kdatemax\||\|kdatemax$)/g)) {
            modified = `kdatemax|${modified}`;
        }

        return modified;
    } else if (baseValidation && Array.isArray(baseValidation)) {
        let modified = [...baseValidation];

        if (!modified.find(([rule]) => rule === "kdate")) {
            // Avslutar resten av valideringen om kdate failar (det är vad ^ betyder)
            modified = [["^kdate"], ...modified];
        }

        if (!modified.find(([rule]) => rule === "kdatemin")) {
            modified = [["kdatemin"], ...modified];
        }

        if (!modified.find(([rule]) => rule === "kdatemax")) {
            modified = [["kdatemax"], ...modified];
        }

        return modified;
    }

    return baseValidation;
};
